import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchNewss(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/news/list',{params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchNews(ctx, qureyParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/news`, {params:qureyParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addNews(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/news', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    fetchLanguages(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/language/list')
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    deleteNews(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.delete('/news',{params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    }

  },
}
